import { classes, DOM } from '../const';

const { isOpen, isHidden, isBlack } = classes;

const { $document } = DOM;

export const initDropdown = $el => {
  const $btn = $el.find('.js-dropdown-btn');
  const $body = $el.find('.js-dropdown-body');
  const $$options = $el.find('.js-dropdown-option');
  const $placeholder = $btn.find('.js-dropdown-placeholder');
  const $select = $el.find('.js-dropdown-select select');
  const $$selectOptions = $select.find('option');

  $body.removeClass(isHidden).hide();

  $btn.click(event => {
    event.preventDefault();
    $el.toggleClass(isOpen);

    if ($el.hasClass(isOpen)) {
      $body.fadeIn();
    } else {
      $body.fadeOut();
    }
  });

  $$options.each((i, option) => {
    const value = $(option).data('value');
    const displayValue = $(option).data('display-value');

    $(option).click(event => {
      event.preventDefault();

      if (displayValue) {
        $el.addClass(isBlack);
        $placeholder.text(displayValue);
      }

      if ($select.length) {
        $$selectOptions.each((j, selectOption) => {
          if ($(selectOption).val() === value) {
            $(selectOption).prop('selected', true);
          } else {
            $(selectOption).prop('selected', false);
          }
        });
        $select.change();
      }

      $el.removeClass(isOpen);
      $body.fadeOut();
    });
  });

  $document.click(event => {
    const $targetParent = $(event.target).closest($el[0]);

    if (!$targetParent.length) {
      $el.removeClass(isOpen);
      $body.fadeOut();
    }
  });

};

const dropdowns = () => {
  const $$dropdowns = $('.js-dropdown');

  $$dropdowns.each((i, el) => {
    initDropdown($(el));
  });
};

export default dropdowns;
